/* eslint-disable eqeqeq */
import { Component } from 'react';
import { Container } from 'reactstrap';
import { Utils, Images } from 'Helpers';
//Auth
import { FixtureComponent, MultiBanner, MobHeader } from 'Components';
//TempFixture
import { ReduxHOC } from 'HOC';
import { Trans } from 'react-i18next';
import Moment from "react-moment";
import CountDownCustom from "../../Views/CountDownCustom";

class Fixtures extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selected_league: Utils.getMultiLeg(),

      WeekPosting: false,
      Weeks: [],
      SelectedWeek: '',

      posting: false,
      FixturesList: [],

      opening: false,
      openingItem: '',
      CurrentFixtuerSelected: '',
      MatchSummary: {},
      lastupdate: new Date().valueOf(),
      contestData : JSON.parse(localStorage.getItem('contestData')) || {}
    }
    this.slider = null
  }

  LeagueToggle = (item) => {
    this.setState({
      selected_league: item,
      lastupdate: new Date().valueOf()
    })
  }

  checkDate = (inputDate) => {
    const now = new Date() && new Date();
		const enteredDate = new Date(inputDate);
		const differenceInHours = Math.abs(enteredDate - now) / (1000 * 60 * 60);
		const isSameDay = now.toDateString() === enteredDate.toDateString();
		const isWithin24Hours = differenceInHours <= 24;
        if (isSameDay) {
			return "Today";
		} else if (enteredDate > now) {
			if (isWithin24Hours) {
				return "Tomorrow";
			} else {
				return "Future Date";
			}
		} else {
			if (isWithin24Hours) {
				return "Yesterday";
			} else {
				return "Past Date";
      }
    }
};

goBack =()=>{
  this.props.history.push('/')
}

  render() {
    const {
      selected_league,
      lastupdate,
      contestData

    } = this.state;
    let  MobHeaderProps={
      // titleContest:contestData,
      centerTitle: 'Fixtures',
      backTitleAction:"",
      drawerMenu:true,
      backHandle:true,
      backTo: '/'
  }


    return (
      <Container className='xpt28-p cont-spc-mob main-cont-fixture'>
        <MobHeader {...MobHeaderProps}/>
        <div className='title-for-dashboard my-team view-link-mob'>
          <div className='contest-info-myteam gray'>
            <div className='contest-info-head'>
              <span className='curved-btn' onClick={() => this.goBack()}>
                  <span><i className="icon-previous"/></span>
              </span>
              <h6>{contestData.contest_name}</h6>
            </div>
              <div className='contest-info-subhead'>
                <h5>{contestData.league_name}</h5>
                <span className='gameweek-lbl'>{Utils.getMultiLeg().week_abbr[contestData.start_week]} - {Utils.getMultiLeg().week_abbr[contestData.end_week]}</span>
                <span className='seprate'>|</span>
                <div className="schedule-date">
                    {this.checkDate(contestData.deadline_date) === "Today" && !Utils.hasDateTimePassed(Utils.getUtcToLocal(contestData.deadline_date))? (
                        <div className="count-clock">
                            <CountDownCustom
                                targetDate={Utils.getUtcToLocal(contestData.deadline_date)}
                            />
                        </div>
                    ) :
                    contestData.status == "3" ? <div className='completed'>Completed</div> :
                    (this.checkDate(contestData.deadline_date) === "Yesterday" || this.checkDate(contestData.deadline_date) === "Past Date") || Utils.hasDateTimePassed(Utils.getUtcToLocal(contestData.deadline_date))? 
                          <div className='contest-live'>Live <img src={Images.LIVE_RED_ARROW} alt="next-live"/></div>
                      :
                      (
                        <div className="schedule-date">
                            <Moment
                                date={Utils.getUtcToLocal(contestData.deadline_date)}
                                format="DD MMM - hh:mm A"
                            />
                        </div>
                    )}
                </div>
              </div>
          </div>
        </div>
       {false &&  <div className="heading-leagues m-b-spc">
          <div className="heading-main only-mob"><Trans>Fixtures</Trans></div>
          {/* <Select
              {...SelectProps}
              placeholder={t("Select Captain")}
              value={league}
              options={LeagueType}
              onChange={(e) => this.handleChange(e, "league")}
            /> */}
        </div>}
        <div className='cfixt-bne multibanner-wrap fixture'>
          {/* <Banner type='55' paddingBottom  bannerLobby={true}/> */}
          <MultiBanner type='52'  bannerLobby={true}/>
        </div>
        {
          // Auth.getAuth() ?
          // <FixtureComponent
          //   selected_league={selected_league}
          //   lastupdate={lastupdate}
          // />
          // :
          // <TempFixture />
          <div className='ourt-white-block'>
              <FixtureComponent
                selected_league={selected_league}
                lastupdate={lastupdate}
                contestData={contestData}
              />
          </div>
          
        }
      </Container>
    )
  }
}

Fixtures.propTypes = {}
export default ReduxHOC(Fixtures)